/**
 * characterCard.tsx
 */
import Background from '@components/atoms/images/characterBackground';
import Card from '@shared/types/props/card';
import Container from '@components/atoms/container/characterItemContainer';
import IACorner from '@shared/classes/iacorner';
import Image from '@components/atoms/images/characterImage';
import MainContext from '@shared/components/utils/context/mainContext';
import { memo, useContext } from 'react';

/**
 * Character card component for IA Corner displays.
 * Renders a card showing a character with background and image, with focus indicators
 * and lazy loading support for performance optimization.
 *
 * @param {Props} props - Component props including item, index, and onClick handler
 * @returns {JSX.Element | null} Character card element or null if not in view
 */
function CharacterCard({ focused, hide, item, onClick }: Card) {
  const { hoverAsset } = useContext(MainContext);
  const { characterBackground, characterImage } = (item as IACorner) || {};

  return (
    <Container
      id='characterCardContainer'
      backgroundColor={(item as IACorner)?.characterBackground}
      active={focused}
      hide={hide}
      delay={200}
      onClick={onClick}
      onMouseEnter={() => hoverAsset(item)}
    >
      <Background src={characterBackground} />
      <Image src={characterImage} />
    </Container>
  );
}

export default memo(CharacterCard);
